/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: summary.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  GetCallSummariesRequest,
  GetCallSummariesResponse,
  GetCaseSummaryRequest,
  GetCaseSummaryResponse,
  RegenerateSummaryRequest,
  RegenerateSummaryResponse,
  UpdateSummaryRequest,
  UpdateSummaryResponse,
} from '../types/summary';

export const createSummaryService = (transport: Transport) => ({
  async getCallSummaries(
    request: GetCallSummariesRequest,
    options: RequestOptions = {},
  ): Promise<GetCallSummariesResponse> {
    const { organization_id, program_id, case_id } = request;
    const url = getApiPath(API_METHODS.SummaryService.GetCallSummaries, {
      organization_id,
      program_id,
      case_id,
    });
    return transport.get<GetCallSummariesResponse>(url, options);
  },

  async getCaseSummary(
    request: GetCaseSummaryRequest,
    options: RequestOptions = {},
  ): Promise<GetCaseSummaryResponse> {
    const { organization_id, program_id, case_id } = request;
    const url = getApiPath(API_METHODS.SummaryService.GetCaseSummary, {
      organization_id,
      program_id,
      case_id,
    });
    return transport.get<GetCaseSummaryResponse>(url, options);
  },

  async updateSummary(
    request: UpdateSummaryRequest,
    options: RequestOptions = {},
  ): Promise<UpdateSummaryResponse> {
    const { organization_id, program_id, case_id, summary_id, ...body } = request;
    const url = getApiPath(API_METHODS.SummaryService.UpdateSummary, {
      organization_id,
      program_id,
      case_id,
      summary_id,
    });
    return transport.post<UpdateSummaryResponse>(url, body, options);
  },

  async regenerateSummary(
    request: RegenerateSummaryRequest,
    options: RequestOptions = {},
  ): Promise<RegenerateSummaryResponse> {
    const { organization_id, program_id, case_record_id, ...body } = request;
    const url = getApiPath(API_METHODS.SummaryService.RegenerateSummary, {
      organization_id,
      program_id,
      case_record_id,
    });
    return transport.post<RegenerateSummaryResponse>(url, body, options);
  },
});

export type SummaryService = ReturnType<typeof createSummaryService>;
